<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style> 
  @import "./style/home.css";
  @import "./style/sx.css";
  @import "./style/index.css";
  @import "./style/tabletree.css";

  #app {
    height: 100%;
    width: 100%;
    margin: 0px 0px 0px 0px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue